import { render, staticRenderFns } from "./GeneralInfoBlock.vue?vue&type=template&id=19d4a56d&scoped=true&"
import script from "./GeneralInfoBlock.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfoBlock.vue?vue&type=style&index=0&id=19d4a56d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4a56d",
  null
  
)

export default component.exports